import React, {FC} from 'react'
import {MDBContainer} from 'mdb-react-ui-kit'
import FadeIn from 'react-fade-in'



interface PropType  {
  title?: String,
  children?: any
}

const defaultProps: PropType = {
  title: 'عنوان درج نشده',
  children: ''
}

const AppContainer:FC<PropType> = ({children, title})  => {
  return (
    <FadeIn>
      <MDBContainer className={'text-center w-100 h-100 mt-5 mb-2'} fluid={true}>
        <div className={'w-100 flex items-center justify-end h-20 p-4 content-header'}>
          <h3 className={'text-white text-right mr-4'}>
            {title}
          </h3>
        </div>
          <div className='card mb-10 h-100'>
            <div className='card-body py-8 h-100'>
              {children}
            </div>
          </div>
      </MDBContainer>
    </FadeIn>

  )
}
AppContainer.defaultProps = defaultProps

export {AppContainer}
